"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-Magnifier" },
      _react2.default.createElement("path", { d: "M15.77 14.709l-4.534-4.534a6.013 6.013 0 1 0-1.061 1.061l4.534 4.534a.75.75 0 1 0 1.061-1.061zM6.5 11A4.5 4.5 0 1 1 11 6.5 4.505 4.505 0 0 1 6.5 11z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M19.77 18.709l-5.464-5.463a7.5 7.5 0 1 0-1.06 1.06l5.463 5.464a.75.75 0 1 0 1.061-1.061zM2.5 8.5a6 6 0 1 1 6 6 6.007 6.007 0 0 1-6-6z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'Magnifier';
exports.default = WrappedIcon;

